import React from "react"
import scrollTo from "gatsby-plugin-smoothscroll"
const Navbar = () => {
  return (
    <div className="section">
      <div className="container">
        <div className="navbar-wrapper">
          <div
            role="button"
            onClick={() => scrollTo("#home")}
            className="name"
            tabIndex={0}
          >
            <div className="photoProfile" ></div>
            <label style={{marginTop: "20px", marginLeft: "10px"}}>Portfolio de Jean.</label>
          </div>
          <div className="links-wrapper">
            <button onClick={() => scrollTo("#work")}>Proyectos</button>
            <button onClick={() => scrollTo("#about")}>Mi Perfil</button>
            <button onClick={() => scrollTo("#contact")}>Contacto</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Navbar
